import { render } from "./artistComponent.vue?vue&type=template&id=35681a76&scoped=true"
import script from "./artistComponent.vue?vue&type=script&lang=js"
export * from "./artistComponent.vue?vue&type=script&lang=js"

import "./artistComponent.vue?vue&type=style&index=0&id=35681a76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35681a76"]])

export default __exports__